import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, exhaustMap, withLatestFrom } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from '../../../../visa';
import { AgingPeriodActions } from '../actions';
import { AgingPeriodStates } from '../states';
import { AgingPeriodSelectors } from '../selectors';
import {
  AgingPeriodService, AgingPeriodContainerModel
} from 'blg-akaun-ts-lib';
import { AgingPeriodFacade } from "../../facades/aging-period.facade";
import { Store } from "@ngrx/store";

@Injectable()
export class AgingPeriodEffects {

    private readonly apiVisa = AppConfig.apiVisa;
    private readonly masterVisa = AppConfig.masterVisa;

    selectAgingPeriod$ = createEffect(() => this.actions$.pipe(
      ofType(AgingPeriodActions.selectAgingPeriod),
      exhaustMap(action => this.agingPeriodService.getByGuid(action.container.guid.toString(), this.apiVisa).pipe(
        map((a: any) => {
          return AgingPeriodActions.selectAgingPeriodSuccess({ container: a.data});
        }),
        catchError(err => {
          return of(AgingPeriodActions.selectAgingPeriodFailed({error: err.message}));
        })
      ))
    ));

    create$ = createEffect(() => this.actions$.pipe(
      ofType(AgingPeriodActions.createInit),
      exhaustMap(action => this.agingPeriodService.post(action.container, this.apiVisa).pipe(
        map((a: any) => {
          this.toastr.success(
            'The Aging Period has been created',
            'Success',
            {
              tapToDismiss: true,
              progressBar: true,
              timeOut: 1300
            }
          );
          this.store.dispatch(AgingPeriodActions.selectAgingPeriod({ container:  action.container?.bl_fi_aging_period_hdr }));
          this.viewColFacade.onNextAndReset(0,2);
          return AgingPeriodActions.createSuccess({ container: action.container});
        }),
        catchError(err => {
          this.toastr.error(
            err.message,
            'Error',
            {
              tapToDismiss: true,
              progressBar: true,
              timeOut: 1300
            }
          );
          return of(AgingPeriodActions.createFailed({error: err.message}));
        })
      ))
    ));

    edit$ = createEffect(() => this.actions$.pipe(
      ofType(AgingPeriodActions.editInit),
      withLatestFrom(
        this.store.select(AgingPeriodSelectors.selectAgingPeriod),
        this.store.select(AgingPeriodSelectors.selectLines),
      ),
      exhaustMap(([action, hdr, line]) => {
        hdr.name = action.form.name;
        if(hdr.period_type==='MONTH' && action.form.num_months){
          hdr.type = action.form.num_months;
        }
        const updatedContainer = new AgingPeriodContainerModel();
        updatedContainer.bl_fi_aging_period_hdr = hdr;
        updatedContainer.bl_fi_aging_period_line = line;

        return this.agingPeriodService.put(updatedContainer, this.apiVisa).pipe(
        map((a: any) => {
          this.toastr.success(
            'The Aging Period has been updated',
            'Success',
            {
              tapToDismiss: true,
              progressBar: true,
              timeOut: 1300
            }
          );

          this.viewColFacade.resetIndex(0);
          return AgingPeriodActions.editSuccess({ container: a.data});
        }),
        catchError(err => {
          this.toastr.error(
            err.message,
            'Error',
            {
              tapToDismiss: true,
              progressBar: true,
              timeOut: 1300
            }
          );
          return of(AgingPeriodActions.editFailed({error: err.message}));
        })
      )})
    ));

    constructor(
      private actions$: Actions,
      private toastr: ToastrService,
      private agingPeriodService: AgingPeriodService,
      private viewColFacade: AgingPeriodFacade,
      private store: Store<AgingPeriodStates>,
    ) {}
}
